import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';

import { AdminLayoutComponent } from '../theme/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from '../theme/auth-layout/auth-layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';


import { LoginComponent } from './sessions/login/login.component';
import { RegisterComponent } from './sessions/register/register.component';
import { AuthGuard } from '@core';

const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { title: 'Dashboard', titleI18n: 'dashboard' },
      },
      {
        path: 'system',
        loadChildren: () => import('./system/system.module').then(m => m.SystemModule),
        data: { title: 'System', titleI18n: 'system' },
      },
     
      {
        path: 'category',
        loadChildren: () => import('./category/category.module').then(m => m.CategoryModule),
        data: { title: 'category', titleI18n: 'category' },
      },

        {
          path: 'statistical',
          loadChildren: () => import('./statistical/statistical.module').then(m => m.StatisticalModule),
          data: { title: 'statistical', titleI18n: 'statistical' },
        },
       

      {
        path: 'cms',
        loadChildren: () => import('./cms/cms.module').then(m => m.CmsModule),
        data: { title: 'manage', titleI18n: 'manage' },
      },
 
      
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
        data: { title: 'Sessions', titleI18n: 'Sessions' },
      },
      
      {
        path: 'sessions',
        loadChildren: () => import('./sessions/sessions.module').then(m => m.SessionsModule),
        data: { title: 'Sessions', titleI18n: 'Sessions' },
      },
      

      {
        path: 'kns',
        loadChildren: () => import('./kns/kns.module').then(m => m.KnsModule),
        data: { title: 'manage', titleI18n: 'manage' },
      },
 


      {
        path: 'giao-vien',
        loadChildren: () => import('./student/student.module').then(m => m.StudentModule),
        data: { title: 'manage', titleI18n: 'manage' },
      },
      

      {
        path: 'report',
        loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
        data: { title: 'report', titleI18n: 'report' },
      },
    ],
  
  },
  
  {
    path: 'login',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
        data: { title: 'Login', titleI18n: 'Login' },
      },
      {
        path: 'register',
        component: RegisterComponent,
        data: { title: 'Register', titleI18n: 'Register' },
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
    }),
  ],
  exports: [RouterModule],
})
export class RoutesRoutingModule { }
